import { render, staticRenderFns } from "./PCGovernanceItemSmall.vue?vue&type=template&id=bdeed472&scoped=true"
import script from "./PCGovernanceItemSmall.vue?vue&type=script&setup=true&lang=js"
export * from "./PCGovernanceItemSmall.vue?vue&type=script&setup=true&lang=js"
import style0 from "./PCGovernanceItemSmall.vue?vue&type=style&index=0&id=bdeed472&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bdeed472",
  null
  
)

export default component.exports